import { __extends } from "tslib";
import * as React from 'react';
import { utils } from 'pro-gallery-lib';
function mouseFollower(listener) {
    var x = 0;
    var y = 0;
    var mouseIn = false;
    return {
        init: function (container) {
            var onMouseEnter = function (e) {
                if (!mouseIn) {
                    mouseIn = true;
                    x = e.pageX;
                    y = e.pageY;
                    listener(mouseIn, {
                        x: x,
                        y: y,
                    });
                    return true;
                }
                return false;
            };
            container.addEventListener('mousemove', function (e) {
                if (onMouseEnter(e)) {
                    return;
                }
                x = e.pageX;
                y = e.pageY;
                if (mouseIn) {
                    listener(mouseIn, {
                        x: x,
                        y: y,
                    });
                }
            });
            container.addEventListener('mouseenter', function (e) {
                onMouseEnter(e);
            });
            container.addEventListener('mouseleave', function () {
                mouseIn = false;
                if (listener) {
                    listener(mouseIn, {
                        x: x,
                        y: y,
                    });
                }
            });
        },
    };
}
var CursorController = /** @class */ (function (_super) {
    __extends(CursorController, _super);
    function CursorController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            position: {
                x: 0,
                y: 0,
            },
            isMouseEnter: false,
        };
        _this.containerRef = { current: null };
        _this.setPosition = utils.throttle(function (position) {
            _this.setState({
                position: position,
            });
        }, 50);
        _this.follower = mouseFollower(function (isMouseEnter, position) {
            _this.setState({ isMouseEnter: isMouseEnter }, function () {
                _this.setPosition(position);
            });
        });
        return _this;
    }
    CursorController.prototype.componentDidMount = function () {
        this.follower.init(this.containerRef.current);
    };
    CursorController.prototype.render = function () {
        var children = this.props.children;
        var _a = this.state, position = _a.position, isMouseEnter = _a.isMouseEnter;
        return children({
            containerRef: this.containerRef,
            position: position,
            isMouseEnter: isMouseEnter,
        });
    };
    return CursorController;
}(React.Component));
export { CursorController };
//# sourceMappingURL=mouseCursorPosition.js.map